import React from "react"
import Layout from "../components/layout"
import Head from "../components/head"

import { Link, graphql, useStaticQuery } from "gatsby"


import GallerySmall from "../components/gallerySmall"

const type = "moje_inwencje";

const Inne = () => {
  
  const contentfullData = useStaticQuery(graphql`
  query {
    allContentfulAlbum(filter: {node_locale: { eq: "pl" }, typ: { eq: "moje inwencje" } }) {
      edges {
        node {
          nazwa
          typ
          zdjecie_albumu{
           fluid(maxHeight: 2000 maxWidth: 2000){
            ...GatsbyContentfulFluid
          }
          }
          }
        }
      }
    }
  `)
  
  return (
    <Layout>
      <Head title={type}></Head>
      <GallerySmall
        contentfullData={contentfullData}
        title={type}
      ></GallerySmall>
    </Layout>
  )
}

export default Inne
